module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card monthly-collisions"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('LineChart', {
    attrs: {
      "chart-data": _vm.monthlyCollisions,
      "chart-data-label-y": 'Number of collisions',
      "chart-data-label-x": 'Months',
      "legend": _vm.legend,
      "additional-datasets": _vm.additionalDatasets,
      "line-color": _vm.lineColor,
      "border-width": '1',
      "background-color": _vm.backgroundColor,
      "point-border-color": _vm.pointBorderColor,
      "point-background-color": _vm.pointBackgroundColor
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "card-h2 s-icon"
  }, [_c('span', [_c('i', {
    staticClass: "material-icons card-icon"
  }, [_vm._v("warning")]), _vm._v(" Monthly Collisions")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-013c174a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lineCharts/MonthlyCollisions.vue
// module id = 416
// module chunks = 1